// extracted by mini-css-extract-plugin
module.exports = {"mobile-alert-container":"index__mobile-alert-container___hV1Ny"};